import { Component, Input, OnInit } from "@angular/core";
import { NavEntity } from "../../models";
import { forkJoin } from "rxjs/observable/forkJoin";
import { BehaviorSubject, Subscription } from "rxjs";
import { KpiExplorerPage } from "../../pages/kpi-explorer/kpi-explorer";
import { ModalController } from "ionic-angular";
import { StarmsClientProvider } from "../../providers/starms-client/starms-client";
import { TimeProvider } from "../../providers/time/time";
import { KpiProvider } from "../../providers/kpi/kpi";
import { IKpi, Kpi } from "../../models/kpi";
import { Mathematics } from "../../app/mathematics";
import { KpiDetailsPage } from "../../pages/kpi-details/kpi-details";
import { KpiPowerGenPage } from "../../pages/kpi-power-gen/kpi-power-gen";
import { TrendExplorer_2Page } from "../../pages/trend-explorer-2/trend-explorer-2";
import { DemoProvider } from "../../providers/demo/demo";
import { TemplateProvider } from "../../providers/template/template";
import * as moment from "moment";
import { map } from "rxjs/operators";

const capitalize = (s) => {
  if (typeof s !== "string") return "";
  return s.charAt(0).toUpperCase() + s.slice(1);
};

@Component({
  selector: "kpi",
  templateUrl: "kpi.html",
})
export class KpiComponent implements OnInit {
  _entity: NavEntity;

  istEntities = {
    customer: [2724, 343, 286],
    site: [2911, 406, 339],
    train: [4757, 4758, 681, 568],
  };
  @Input()
  set entity(value: NavEntity) {
    if (value) {
      this._entity = value;
      const entityType = this._entity.getType();
      if (this.istEntities[entityType].indexOf(value.getId()) !== -1) {
        this.isIst = true;
      }
      if (this._entity.getId() === 381 && this._entity.getType() === "train") {
        this.energyReady = {
          value: false,
        };
        this.getEnergyTag();
      }
      this.cancelSubscriptions();
      this.getKpis();
      this.getAlarms();
      this.getTemplate();
    }
  }
  @Input() refresh: BehaviorSubject<number>;

  kpiInfo: { [key: string]: IKpi } = {};
  alarmsInfo: any;
  kpiReady: any;
  kpiError = false;
  energyReady: any;
  alarmsReady = false;
  alarmsError = false;
  timeParams;
  subscriptions: Subscription[] = [];
  energyArea: boolean;
  isIst = false;
  templateConfig: any;

  constructor(
    private modalCtrl: ModalController,
    private starms: StarmsClientProvider,
    private time: TimeProvider,
    private kpi: KpiProvider,
    public demo: DemoProvider,
    private templateProvider: TemplateProvider
  ) {
    this.timeParams = this.time.getTimeParams(7);
    this.kpiReady = {
      value: false,
    };
    this.energyReady = this.kpiReady;
  }

  ngOnInit() {
    this.refresh.subscribe((value) => {
      if (this._entity) {
        this.timeParams = value;
        this.cancelSubscriptions();
        this.getKpis();
        this.getAlarms();
        if (
          this._entity.getId() === 381 &&
          this._entity.getType() === "train"
        ) {
          this.energyReady = {
            value: false,
          };
          this.getEnergyTag();
        }

        this.getTemplate();
      }
    });
  }

  /**
   * Get current and previous kpi data for set entity
   */
  private getKpis(): void {
    this.kpiReady.value = false;
    this.kpiError = false;
    let queryParams = {
      from: this.timeParams.from,
      to: this.timeParams.to,
    };
    queryParams[this._entity.getType() + "Id"] = this._entity.getId();
    let queryParamsPrev = {
      from: this.timeParams.prevFrom,
      to: this.timeParams.prevTo,
    };
    queryParamsPrev[this._entity.getType() + "Id"] = this._entity.getId();

    let req1 = forkJoin(
      this.starms.get(["kpis/generic"], queryParams).pipe(
        map((r: any[]) =>
          r.map((el) => {
            return {
              name: el.name,
              value: el.value,
              unitValue: el.unitValue,
              description: el.description,
            };
          })
        )
      ),
      this.starms.get(["kpis/generic"], queryParamsPrev).pipe(
        map((r: any[]) =>
          r.map((el) => {
            return {
              name: el.name,
              value: el.value,
              unitValue: el.unitValue,
              description: el.description,
            };
          })
        )
      )
    ).subscribe(
      ([kpi, prevKpi]) => {
        this.kpiInfo = this.kpi.computeKpis(kpi, prevKpi);
        this.kpiReady.value = true;
        if (
          this._entity.getId() === 381 &&
          this._entity.getType() === "train"
        ) {
          this.energyReady = {
            value: false,
          };
          this.getEnergyTag();
        } else {
          this.energyArea = this.kpiInfo.hasOwnProperty("AveragePower");
        }
      },
      (error) => {
        console.log("error", error);
        this.kpiInfo = this.kpi.computeKpis([], []);
        this.kpiReady.value = true;
        this.kpiError = true;
      },
      () => {
        this.kpiReady.value = true;
      }
    );
    this.subscriptions.push(req1);
  }

  getAlarms() {
    this.alarmsError = false;
    if (this._entity.getType() === "train") {
      this.alarmsReady = false;
      let req2 = forkJoin(
        this.starms.get(["events/trains", this._entity.getId()], {
          eventType: "250",
          to: this.timeParams.to,
          tagIdentifierOption: "1",
          from: this.timeParams.from,
        }),
        this.starms.get(["events/trains", this._entity.getId()], {
          eventType: "250",
          to: this.timeParams.prevTo,
          tagIdentifierOption: "1",
          from: this.timeParams.prevFrom,
        })
      ).subscribe(
        ([alarms, prevAlarms]) => {
          this.alarmsInfo = {
            current: {
              counter: 0,
            },
            previous: {
              counter: 0,
            },
          };
          this.alarmsInfo.current.counter = alarms ? alarms.length : 0;
          this.alarmsInfo.previous.counter = prevAlarms ? prevAlarms.length : 0;
        },
        (error) => {
          this.alarmsError = true;
        },
        () => {
          this.alarmsReady = true;
        }
      );
      // Store the subscription reference for further deletion
      this.subscriptions.push(req2);
    }
  }

  getEnergyTag(): void {
    this.energyReady.value = false;
    let request = forkJoin(
      this.starms.get(["signals/tags/", 2971158], {
        filter: "optim",
        to: this.timeParams.to,
        from: this.timeParams.from,
      }),
      this.starms.get(["signals/tags/", 2971158], {
        filter: "optim",
        to: this.timeParams.prevTo,
        from: this.timeParams.prevFrom,
      })
    ).subscribe(([current, previous]) => {
      this.kpiInfo["Energy"] = new Kpi();
      this.kpiInfo["Energy"].currentValue = Mathematics.arrayVariation(
        current.tagData.map((x) => x.value)
      );
      this.kpiInfo["Energy"].previousValue = Mathematics.arrayVariation(
        previous.tagData.map((x) => x.value)
      );
      this.kpiInfo["Energy"].hasData = true;
      this.kpiInfo["Energy"].format(1);
      this.kpiInfo["AveragePower"] = new Kpi();
      if (this.kpiInfo.hasOwnProperty("KpiSh")) {
        if (this.kpiInfo["KpiSh"].hasData) {
          this.kpiInfo["AveragePower"].currentValue =
            Mathematics.arrayVariation(current.tagData.map((x) => x.value)) /
            this.kpiInfo["KpiSh"].currentValue;
        }
        if (this.kpiInfo["KpiSh"].previousValue > 0) {
          this.kpiInfo["AveragePower"].currentValue =
            Mathematics.arrayVariation(previous.tagData.map((x) => x.value)) /
            this.kpiInfo["KpiSh"].previousValue;
        }
        this.kpiInfo["AveragePower"].format(1);
      }
      this.energyArea = true;
      this.energyReady.value = true;
    });
    this.subscriptions.push(request);
  }

  cancelSubscriptions(): void {
    for (let sub of this.subscriptions) {
      sub.unsubscribe();
    }
    this.subscriptions = [];
  }

  showKpiExplorer(type: string): void {
    this.modalCtrl
      .create(KpiExplorerPage, {
        time: this.timeParams,
        timeRange: this.timeParams.range,
        kpi: type,
        entity: this._entity,
        isIst: this.isIst,
      })
      .present();
  }

  showKpiDetails(type: string, currentValue: number): void {
    if (type === "power") {
      if (this._entity.getId() === 381 && this._entity.getType() === "train") {
        this.modalCtrl
          .create(TrendExplorer_2Page, {
            initialData: [2971158],
          })
          .present();
      } else {
        this.modalCtrl
          .create(KpiPowerGenPage, {
            time: this.timeParams,
            timeRange: this.timeParams.range,
            kpi: type,
            entity: this._entity,
            isIst: this.isIst,
          })
          .present();
      }
    } else {
      this.modalCtrl
        .create(KpiDetailsPage, {
          type: type,
          from: this.timeParams.from,
          to: this.timeParams.to,
          id: this._entity.getId(),
          current: currentValue,
        })
        .present();
    }
  }

  getTemplate(): void {
    if (this._entity.getType() === "train") {
      this.templateConfig = {
        availability:
          this.templateProvider.currentTemplate[
            capitalize(this._entity.getType())
          ].KPI.Availability,
        reliability:
          this.templateProvider.currentTemplate[
            capitalize(this._entity.getType())
          ].KPI.Reliability,
        serviceHours:
          this.templateProvider.currentTemplate[
            capitalize(this._entity.getType())
          ].KPI.ServiceHours,
        alarms:
          this.templateProvider.currentTemplate[
            capitalize(this._entity.getType())
          ].KPI.Alarms,
        averagePower:
          this.templateProvider.currentTemplate[
            capitalize(this._entity.getType())
          ].KPI.AveragePower,
        powerGenerated:
          this.templateProvider.currentTemplate[
            capitalize(this._entity.getType())
          ].KPI.PowerGenerated,
        successfulStarts:
          this.templateProvider.currentTemplate[
            capitalize(this._entity.getType())
          ].KPI.SuccessfulStarts,
        trips:
          this.templateProvider.currentTemplate[
            capitalize(this._entity.getType())
          ].KPI.Trips,
      };
    } else {
      this.templateConfig = {
        availability:
          this.templateProvider.currentTemplate[
            capitalize(this._entity.getType())
          ].KPI.Availability,
        reliability:
          this.templateProvider.currentTemplate[
            capitalize(this._entity.getType())
          ].KPI.Reliability,
        serviceHours:
          this.templateProvider.currentTemplate[
            capitalize(this._entity.getType())
          ].KPI.ServiceHours,
      };
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/kpi/kpi.ts